module.exports = __webpack_public_path__ + "img/t1-i1.616bb594.svg";